import '../src/polyfills.js'
import { createApp, reactive, h } from 'vue'
import NrDatePicker from '../src/vue_shared/components/datepicker.vue'

function initDatepicker(selector: string) {
  const datepickerEls = document.querySelectorAll(selector)

  datepickerEls.forEach((el: HTMLInputElement) => {
    // A vue instance for this element already exist, do nothing.
    if ($(el).data('vue')) return

    const mountEl = document.createElement('div')
    el.parentNode.insertBefore(mountEl, el)
    // NOTE: Setting the hidden attribute here so that screenreaders know it is
    // hidden and not to be tabbed into.
    el.hidden = true
    el.style.display = 'none'

    // Does this datepicker have a sibling?
    // @ts-ignore: this uses `find` to protect against XSS, but `find` is missing from the type definition.
    const $siblingEl = $.find(el.getAttribute('data-sibling'))
    // @ts-ignore: this uses `find` to protect against XSS, but `find` is missing from the type definition.
    const $autoSubmitForm = $.find(el.getAttribute('data-auto-submit-form'))

    // Data that can be accessed by code outside of the Vue app.
    const publicData = reactive({
      minDate: el.getAttribute('data-min-date'),
      maxDate: el.getAttribute('data-max-date'),
      selected: el.value,
      placeholder: el.getAttribute('placeholder'),
      disabled: el.getAttribute('disabled')
    })
    $(el).data('vue', publicData)

    const vueDatepicker = createApp({
      mounted() {
        const rootEl = this.$el as HTMLElement
        if (rootEl) {
          rootEl.setAttribute('data-id', el.id)
        }
      },
      data() {
        return publicData
      },

      render() {
        return h(
          NrDatePicker,
          {
            minDate: this.minDate,
            maxDate: this.maxDate,
            placeholder: this.placeholder,
            disabled: this.disabled,
            modelValue: this.selected,
            'onUpdate:modelValue': (value: string) => {
              this.selected = value
              this.updateDate(value)
            }
          },
          {
            label: () => el.getAttribute('aria-label')
          }
        )
      },
      methods: {
        updateDate(date: string) {
          el.value = date

          if ($autoSubmitForm.length) {
            $autoSubmitForm.submit()
          }

          // Check if this datepicker has a sibling
          if (!$siblingEl.length) return
          // Check if the sibling datepicker has a vue instance
          const siblingVue = $siblingEl.data('vue')
          if (!siblingVue) return

          if (/start/i.test(el.id)) {
            // If this datepicker is the start datepicker
            // Update the end datepicker's minDate
            siblingVue.minDate = date
          } else if (/end/i.test(el.id)) {
            // If this datepicker is the end datepicker
            // Update the start datepicker's maxDate
            siblingVue.maxDate = date
          }
        }
      }
    })

    vueDatepicker.mount(mountEl)
  })
}

declare global {
  interface Window {
    initDatepicker: typeof initDatepicker
  }
}
window.initDatepicker = initDatepicker
document.addEventListener('DOMContentLoaded', () => {
  window.initDatepicker('.dateSelect')
})
